import React from "react";

export const Thermiques = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none">
      <path
        d="M21.873 30.99C21.7309 30.99 21.5887 30.9299 21.4848 30.826C21.3863 30.727 21.3262 30.5853 21.3262 30.4431C21.3262 30.2949 21.3863 30.1533 21.4848 30.0549C21.6926 29.8525 22.0535 29.8525 22.2613 30.0488C22.3598 30.1582 22.4199 30.2949 22.4199 30.4431C22.4199 30.5853 22.3598 30.722 22.2613 30.826C22.1574 30.9299 22.0147 30.99 21.873 30.99Z"
        fill="#BF2C53"
      />
      <path
        d="M23.4179 29.5573C23.2954 29.5573 23.1724 29.5168 23.0707 29.4326C22.8372 29.2401 22.8038 28.8961 22.9958 28.6626C23.8019 27.6831 24.3296 26.5057 24.5226 25.2561C24.5686 24.957 24.8513 24.7552 25.1466 24.7989C25.4452 24.8449 25.6497 25.1243 25.6033 25.4229C25.3801 26.8661 24.7704 28.2267 23.8396 29.3577C23.7324 29.4895 23.5754 29.5573 23.4179 29.5573Z"
        fill="#BF2C53"
      />
      <path
        d="M20.2324 18.7992V6.74609C20.2324 5.24219 19.0019 4.01172 17.498 4.01172C16.7433 4.01172 16.0652 4.31797 15.5675 4.81563C15.0699 5.31328 14.7636 5.99141 14.7636 6.74609V7.83984H15.8574V6.74609C15.8574 5.84375 16.5957 5.10547 17.498 5.10547C18.4003 5.10547 19.1386 5.84375 19.1386 6.74609V19.5211C21.091 20.2102 22.4199 22.0586 22.4199 24.1531C22.4199 25.4656 21.9058 26.7016 20.9761 27.6313C20.0464 28.5609 18.8105 29.075 17.498 29.075H17.3503C14.9003 29.0039 12.8113 27.0352 12.598 24.5961C12.3957 22.332 13.7519 20.2594 15.8574 19.5211V16.5898H14.7636V18.7992C12.5543 19.9313 11.1324 22.3813 11.5589 25.1102C11.9636 27.7461 14.1566 29.8352 16.8035 30.1305C20.4402 30.5352 23.5136 27.7023 23.5136 24.1531C23.5136 21.818 22.1793 19.7945 20.2324 18.7992Z"
        fill="#BF2C53"
      />
      <path
        d="M18.5918 6.74609V15.9172C18.302 15.6547 17.9137 15.4961 17.498 15.4961C17.0824 15.4961 16.6941 15.6547 16.4043 15.9172V6.74609C16.4043 6.44531 16.5246 6.17188 16.727 5.975C16.9238 5.77266 17.1973 5.65234 17.498 5.65234C18.0996 5.65234 18.5918 6.14453 18.5918 6.74609Z"
        fill="#BF2C53"
      />
      <path
        d="M21.8736 24.1531C21.8736 26.6086 19.8392 28.5992 17.3673 28.5281C15.1853 28.4625 13.3314 26.718 13.14 24.5469C12.9486 22.343 14.4032 20.4398 16.4048 19.9258V17.1367C16.4048 16.5324 16.8943 16.043 17.4986 16.043C18.1029 16.043 18.5923 16.5324 18.5923 17.1367V19.9258C20.4736 20.4125 21.8736 22.1188 21.8736 24.1531Z"
        fill="#BF2C53"
      />
      <path
        d="M14.7637 11.668H15.8574V12.7617H14.7637V11.668Z"
        fill="#BF2C53"
      />
      <path
        d="M14.7637 10.0273H15.8574V11.1211H14.7637V10.0273Z"
        fill="#BF2C53"
      />
      <path
        d="M14.7637 8.38672H15.8574V9.48047H14.7637V8.38672Z"
        fill="#BF2C53"
      />
      <path
        d="M14.7637 13.3086H15.8574V14.4023H14.7637V13.3086Z"
        fill="#BF2C53"
      />
      <path
        d="M14.7637 14.9492H15.8574V16.043H14.7637V14.9492Z"
        fill="#BF2C53"
      />
      <path
        d="M12.5762 6.19922V15.1023C12.5543 15.1078 12.5324 15.1242 12.516 15.1352L12.0293 15.4578L11.5426 15.1352C11.5262 15.1242 11.5043 15.1078 11.4824 15.1023V6.19922C11.4824 5.89844 11.7285 5.65234 12.0293 5.65234C12.3301 5.65234 12.5762 5.89844 12.5762 6.19922Z"
        fill="#BF2C53"
      />
      <path
        d="M12.0296 18.778C11.8224 18.778 11.6332 18.661 11.5402 18.4756L10.4464 16.2881C10.3354 16.066 10.3879 15.7975 10.5739 15.6335C10.7592 15.4689 11.0327 15.4503 11.2389 15.5881L12.0291 16.1153L12.8193 15.5881C13.025 15.4508 13.2984 15.4689 13.4843 15.6335C13.6703 15.7975 13.7228 16.066 13.6117 16.2881L12.518 18.4756C12.4261 18.661 12.2369 18.778 12.0296 18.778Z"
        fill="#BF2C53"
      />
    </svg>
  );
};
